import { FormControl } from '@angular/forms';
import { SignInFormField } from './sign-in-form-field.enum';

export interface SignInForm {
  [SignInFormField.Email]: FormControl<string | null>;
  [SignInFormField.Password]: FormControl<string | null>;
}
